import React, { useEffect, useState } from 'react';
import { ArrowDown } from '@phosphor-icons/react';

/**
 * Sticky bottom CTA visible on mobile only.
 * Hides when the calculator section is in view (no need for CTA there).
 */
export default function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    function check() {
      const calc = document.getElementById('calculator');
      if (!calc) {
        setVisible(true);
        return;
      }
      const rect = calc.getBoundingClientRect();
      // visible when calculator is below the viewport or above by more than 200px
      const aboveViewport = rect.bottom < 100;
      const belowViewport = rect.top > window.innerHeight - 100;
      setVisible(aboveViewport || belowViewport);
    }
    check();
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, []);

  function scrollToCalc() {
    const el = document.getElementById('calculator');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  if (!visible) return null;

  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-neutral-300 p-3 shadow-[0_-4px_16px_rgba(0,0,0,0.08)]"
      data-testid="sticky-mobile-cta"
    >
      <button
        onClick={scrollToCalc}
        data-testid="sticky-cta-button"
        className="w-full h-14 bg-neutral-900 text-white text-sm uppercase tracking-widest flex items-center justify-center gap-2"
      >
        <ArrowDown size={16} weight="bold" />
        Jetzt Pendel-Score berechnen
      </button>
    </div>
  );
}
